import moment from 'moment';
import * as fetchHelpers from '../Fetch';
import * as firebaseHelpers from '../Firebase/';
const API_URL = fetchHelpers.API_URL;

export function getIAVToken(firstName, lastName, email) {
  const payload = {
    firstName,
    lastName,
    email,
  };
  return fetchHelpers
    .makeRequest(API_URL + 'token/ach', payload)
    .send();
}

export async function makeDonation(formData, sessionToken, organizationId) {
  const { uid } = await firebaseHelpers.getCurrentUser(true);
  const payload = {
    organizationId,
    fund: formData.givingOption,
    profile: {
      email: formData.email,
      uid,
      firstName: formData.firstName,
      lastName: formData.lastName,
    },
    transaction: {
      amount: formData.amount,
      currency: 'USD',
    },
    note: formData.note,
    sessionToken,
  };

  if (formData.paymentType === 'cc') {
    payload.card = {
      ccName: formData.ccName || `${formData.firstName} ${formData.lastName}`,
      token: formData.ccToken,
      expiration: `${formData.month}${formData.year}`,
      cvc: formData.cvc,
    };
    payload.paymentType = 'cc';
  } else {
    payload.bankAccount = {
      token: formData.achToken,
      currency: 'USD',
      country: 'US',
    };
    payload.paymentType = 'ach';
  }
  return fetchHelpers.makeRequest(API_URL + 'charge', payload).send();
}

export async function makeDonationLoggedIn(
  formData,
  sessionToken,
  organizationId
) {
  const { uid } = await firebaseHelpers.getCurrentUser(true);
  const payload = {
    note: formData.note,
    paymentType: formData.paymentType,
    last4: formData.last4,
    processorType: formData.processorType,
    organizationId: organizationId,
    fund: formData.givingOption,
    profile: { uid },
    transaction: {
      amount: formData.amount,
      currency: 'USD',
    },
    sessionToken,
  };

  if (
    formData.paymentFrequency === 'recurring' &&
    formData.date &&
    typeof formData.dateFrequency !== 'undefined'
  ) {
    payload.subscription = {
      type: formData.dateFrequency,
      date: moment(formData.date, 'MM/DD/YY').valueOf(),
    };
  }
  return fetchHelpers.makeRequest(API_URL + 'charge', payload).send();
}
